import {
  IFRAME_SOURCE_ID,
  IFRAME_ACTION_CLOSE,
  IFRAME_ACTION_ANALYTICS,
  SPORTCALLER_ANALYTICS_EVENT,
  PAGEVIEW_ANALYTICS_EVENT,
  IFRAME_ACTION_ADDTOSLIP,
  IFRAME_ACTION_ADDTOSLIP_BYO,
  EVENT_PAGE,
  HOME_PAGE,
  DML_PAGE,
  IFRAME_ACTION_NAVIGATE,
  ADDTOSLIP_HOME_PAGE,
  FOOTBALL,
} from '../constants';
import {track} from '@sb/analytics-adapter/src/client';
import {getMessageBus} from '../apis';
import topics from '../apis/topics';

/*
  Helpers
 */
function getBetIds(selection) {
  return selection.replace('OB_OU', '');
}

/*
  Type definitions
 */
type CloseActionType = 'close';
type AnalyticsActionType = 'analytics';
type AddToSlipActionType = 'addToSlip';
type AddToSlipBYOActionType = 'addToSlipBYO';
type NavigateActionType = 'navigate';

type DataType = {
  source: string;
  action: CloseActionType | AnalyticsActionType | AddToSlipActionType | AddToSlipBYOActionType | NavigateActionType;
  payload: any;
};

type EventType = {
  data: DataType;
  origin: string;
};

type AddToSlipPayload = {
  page: string;
  selections: Array<string>;
};

type ByoSelectionDetails = {
  selectionId: string;
  handicap: number;
};

type ByoPrice = {
  type: string;
  numerator: number;
  denominator: number;
};

type AddToSlipBYOPayload = {
  byoEventId: string;
  byoMarketId: string;
  byoSelectionDetails: Array<ByoSelectionDetails>;
  byoPrice: ByoPrice;
};

type NavigationPayload = {
  page: string;
  eventId?: string;
  sport?: string;
  showBYOModal?: boolean;
  hash?: string;
  selectionsIds?: Array<string>;
};

/*
  Handlers
 */
export function close(): void {
  location.hash = '';
}

function analytics(data: any): void {
  const {EventCategory} = data;

  const payload = {...data, ProductContext: 'SportCaller'};
  const event = !!EventCategory ? SPORTCALLER_ANALYTICS_EVENT : PAGEVIEW_ANALYTICS_EVENT;

  track({
    event,
    payload,
  });
}

export function navigate(payload: NavigationPayload): void {
  const messageBus = getMessageBus();
  const {page, eventId, sport = FOOTBALL, showBYOModal, hash = '', selectionsIds} = payload;
  const baseUrl = `/betting/en-gb`;
  const dmlByoPath = 'matches/competition/today/build-your-odds';
  const addToSlipPath = 'https://transact.williamhill.com/betslip/api/bets/addToSlip?url=https://sports.williamhill.com/betting/en-gb&sel='
  const byoModalOpened = showBYOModal ? '?byo=true' : '';

  if (messageBus) {
    switch (page) {
      case EVENT_PAGE:
        location.href = location.origin + [baseUrl, sport, eventId].join('/') + byoModalOpened + hash;
        break;
      case HOME_PAGE:
        messageBus.publish(topics.NAVIGATE, {url: baseUrl});
        break;
      case DML_PAGE:
        messageBus.publish(topics.NAVIGATE, {url: [baseUrl, sport, dmlByoPath].join('/')});
        break;
      case ADDTOSLIP_HOME_PAGE:
        location.href = addToSlipPath + selectionsIds.join(',');
        break;
    }
  }
}

function addToSlip(payload: AddToSlipPayload): void {
  const {selections} = payload
  const betIds = selections.map(getBetIds)

  navigate({page: ADDTOSLIP_HOME_PAGE, selectionsIds: betIds})
}

export function addSelectionsToBetslip(payload: AddToSlipBYOPayload) {
  const messageBus = getMessageBus();
  messageBus.publish(topics.ADDTOSLIP_BYO, payload);
}

function addToSlipBYO(payload: AddToSlipBYOPayload): void {
  const {byoEventId} = payload;
  const gtpUrl = `https://ctgdata.williamhill.com/pds2/catalogs/OB_CG0/events/${byoEventId}/gtpMappings?fields=id&source=stat-attack`;
  const currentUrl = window.location.href;

  fetch(gtpUrl)
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error(`Error while fetching data from ${gtpUrl}`)
      }
    })
    .then(data => {
      const eventId = data.id;
      const isProperPage = currentUrl.includes(`https://sports.williamhill.com/betting/en-gb/football/${eventId}`);
      if (!isProperPage) {
        const eventPageRedirectPayload = {page: EVENT_PAGE, eventId, hash: '#stat-attack'}
        localStorage.setItem('stat-attack', JSON.stringify(payload));
        navigate(eventPageRedirectPayload);
      } else {
        addSelectionsToBetslip(payload);
      }
    })
    .catch(error => {
      console.error(error);
      addSelectionsToBetslip(payload);
      close();
    })
}

/*
  postMessage handler dispatcher
 */
export const postMessageHandler = ({data, origin}: EventType): void => {
  const {source, action, payload} = data;
  const eventOrigin = new URL(origin).origin;
  const iframeOrigin = new URL(process.env.IFRAME_SRC || '').origin;

  if (eventOrigin !== iframeOrigin || source !== IFRAME_SOURCE_ID) {
    return;
  }

  switch (action) {
    case IFRAME_ACTION_CLOSE:
      close();
      break;
    case IFRAME_ACTION_ANALYTICS:
      analytics(payload);
      break;
    case IFRAME_ACTION_ADDTOSLIP:
      addToSlip(payload);
      break;
    case IFRAME_ACTION_ADDTOSLIP_BYO:
      addToSlipBYO(payload)
      break;
    case IFRAME_ACTION_NAVIGATE:
      navigate(payload)
      break;
  }
};
